/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupsmessageattachment2Inputs */

const en_groupsmessageattachment2 = /** @type {(inputs: Groupsmessageattachment2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attachment, only visible in the app`)
};

const de_groupsmessageattachment2 = /** @type {(inputs: Groupsmessageattachment2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anhang, nur in der App zu sehen`)
};

/**
* | output |
* | --- |
* | "Attachment, only visible in the app" |
*
* @param {Groupsmessageattachment2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsmessageattachment2 = /** @type {((inputs?: Groupsmessageattachment2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsmessageattachment2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsmessageattachment2(inputs)
	return de_groupsmessageattachment2(inputs)
});
export { groupsmessageattachment2 as "groupsMessageAttachment" }